import { useQuery } from "@tanstack/react-query";
import api from "../../api";
import { ProjectResource } from "../../types/projectResource";

const useAllProjectResources = (resourceType: string) => {
  return useQuery({
    queryKey: ['projectResources'],
    queryFn: () => api.projects.resources.getAllProjectResources(resourceType),
    select(data) {
      return data.body as Array<ProjectResource>
    }
  })
}

export default useAllProjectResources
